'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
require('../../utils/getThemeProp.js');
require('../../utils/colors.js');
require('../../utils/dates.js');
require('../../utils/numbers.js');
require('../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../utils/strings.js');
require('../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
var safeFetch = require('../../utils/safeFetch.js');
var dom = require('../../utils/dom.js');
var TableWithHeader = require('../components/TableWithHeader/TableWithHeader.js');
var RenderRows = require('../components/RenderRows/RenderRows.js');
var moment = _interopDefault(require('moment-timezone'));
var InfiniteScroll = _interopDefault(require('react-infinite-scroll-component'));
var styledComponents = require('./styled-components.js');

var loader = (React__default.createElement(styledComponents.CenteredContainer, null,
    React__default.createElement(styledComponents.StyledCircularProgress, { size: '35' })));
var endMessage = (React__default.createElement(styledComponents.CenteredContainer, { "data-testid": 'end-message' },
    React__default.createElement(styledComponents.StyledCheckCircleOutlineIcon, { fontSize: 'large' })));
var InfiniteScrollTable = function (props) {
    var headCells = props.headCells, generateRow = props.generateRow, fetchMore = props.fetchMore, _a = props.dense, dense = _a === void 0 ? false : _a, height = props.height, scrollableTarget = props.scrollableTarget, _b = props.hoverable, hoverable = _b === void 0 ? false : _b, _c = props.shouldResetState, shouldResetState = _c === void 0 ? false : _c, _d = props.canDeleteRow, canDeleteRow = _d === void 0 ? false : _d, style = props.style, containerRef = props.containerRef;
    var _e = React.useState(moment().toISOString()), initialFetch = _e[0], setInitialFetch = _e[1];
    var _f = React.useState({
        page: 1,
        rows: [],
        hasMore: true,
    }), _g = _f[0], page = _g.page, rows = _g.rows, hasMore = _g.hasMore, setState = _f[1];
    var fetchData = React.useCallback(function () {
        safeFetch(function () { return fetchMore(page); }, function (data) {
            /* After a deletion in the DB, the parents fetchMore has to adjust to account for the deletions(s) */
            var totalPages = data.totalPages, newRows = data.data;
            var resultingRows = tslib.__spreadArrays(rows, newRows);
            var nextPage = page + 1;
            var moreData = !(nextPage > totalPages);
            setState({
                page: nextPage,
                rows: resultingRows,
                hasMore: moreData,
            });
            if (!dom.hasScroll(containerRef) && moreData) {
                setInitialFetch(function (prev) {
                    var newVal = moment(prev)
                        .add(1, 'second')
                        .toISOString();
                    return newVal;
                }); // Fetch another row.
            }
        });
    }, [rows, page]);
    React.useEffect(function () {
        if (shouldResetState) {
            setState({
                page: 1,
                rows: [],
                hasMore: true,
            });
            setInitialFetch(moment().toISOString());
        }
    }, [shouldResetState]);
    React.useEffect(function () {
        return fetchData();
    }, [initialFetch]);
    var deleteRow = function (id) {
        setState({
            page: page,
            rows: rows.filter(function (r) { return r.id !== id; }),
            hasMore: hasMore,
        });
    };
    var generateDeletableRow = function (row) { return generateRow(row, deleteRow); };
    // If scrollable target is specified we have to remove overflow for the sticky headers to work.
    var styles = scrollableTarget ? tslib.__assign(tslib.__assign({}, style), { overflow: 'inherit' }) : style;
    return (React__default.createElement(InfiniteScroll, { dataLength: rows.length, next: fetchData, hasMore: hasMore, loader: loader, endMessage: endMessage, height: height, scrollableTarget: scrollableTarget, style: styles, hasChildren: Boolean(rows.length) },
        React__default.createElement(TableWithHeader, { headCells: headCells, dense: dense },
            React__default.createElement(RenderRows, { rows: rows, generateRow: canDeleteRow ? generateDeletableRow : generateRow, hoverable: hoverable }))));
};

module.exports = InfiniteScrollTable;
